import { Dialog, DialogActions, DialogContent, DialogTitle, Slider } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useState } from 'react';
import Switch from '@mui/material/Switch';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const TaskProgressGauge = ({ value, height = 40, width = 40, callback }) => {
  const [dialogStatus,setDialogStatus] = useState(false);
  const [inputProgress,setInputProgress] = useState(value);
  const [notify,setNotify] = useState(false);
  const [remark,setRemark] = useState("")

  const isCompact = height < 40 || width < 40;
  // Internal click handler
  const handleClick = (e) => {
    if (callback) {
      setDialogStatus(true);
    }
  };

  const handleCallBack = () =>{
    callback({
        progress:inputProgress,
        notify:notify,
        remark:remark
      });
    setDialogStatus(false);
  }

  const data = {
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: [
          value > 90 ? '#198754' : value > 30 ? '#ffc107' : '#dc3545',
          '#e9ecef',
        ],
        borderWidth: 0,
        cutout: '75%',
      },
    ],
  };

  const options = {
    responsive: false,
    maintainAspectRatio: true,
    // Enable events only if a callback exists
    events: callback ? ['mousemove', 'mouseout', 'click', 'touchstart'] : [], 
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <div 
      className="d-flex align-items-center" 
      onClick={handleClick}
      style={{ 
        cursor: callback ? 'pointer' : 'default',
        width: 'fit-content'
      }}
      role={callback ? "button" : "presentation"}
      aria-label={callback ? "Open progress details" : undefined}
    >
      <div style={{ position: 'relative', width: `${width}px`, height: `${height}px` }}>
        <Doughnut data={data} options={options} width={width} height={height} />
        
        {!isCompact && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '9px',
              fontWeight: 'bold',
              pointerEvents: 'none',
              color:"#000"
            }}
          >
            {value}%
          </div>
        )}
      </div>

      {isCompact && (
        <span 
          className="ms-2 text-secondary" 
          style={{ fontSize: '12px', fontWeight: '500', pointerEvents: 'none' }}
        >
          {value}%
        </span>
      )}

      <Dialog
        open={dialogStatus}
        keepMounted
        onClose={()=>setDialogStatus(false)}
        fullWidth={true}
      >
        <DialogContent>
          <div className='row mt-2'>
              <div className='col-md-12'>
                  <div className="form-floating mb-3">
                    <div className='form-control'>
                        <Slider
                            defaultValue={inputProgress}
                            step={5}
                            aria-label="default"
                            valueLabelDisplay="auto"
                            onChange={(e, newValue)=>setInputProgress(newValue)}
                            min={0}
                            max={100}  
                        />
                    </div>
                    <label>Select Progress <span className='fw-bold'>{inputProgress} %</span></label>
                </div>

                <div className='col-md-12'>
                  <div className="form-floating mb-3">
                    <textarea className="form-control" onChange={(e)=> setRemark(e.target.value)} value={remark} />
                    <label>Remark</label>
                  </div>
                </div>
                <div className='col-md-12'>
                  <Switch
                    checked={notify}
                    onChange={(e)=>setNotify(e.target.checked)}
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button className='btn btn-outline-primary' onClick={handleCallBack}>Update</button>
          </DialogActions>
        </Dialog>

      
    </div>
  );
};

export default TaskProgressGauge;